import { SET_PAYOUTS } from 'constants/index';
import { Payout } from 'models/payout';

export const setPayouts = (payouts: Payout[]) => ({
  type: SET_PAYOUTS,
  payload: payouts,
});
